import { calculateBearingText } from "components/util/Geometry";
import _ from "lodash";

export const getSourceList = (playlist, streamInfo, session, includeVideoOnly = false) => {
    const sources = [];

    if (!playlist) return sources;

    // Video sources
    if (playlist.video && playlist.video.length) {
        playlist.video.forEach((videoItem, i) => {
            if (!videoItem.length) return;

            const sourceStreamData = _.get(streamInfo, [i], {});
            const sourceStreamInfo = _.get(sourceStreamData, "info", {});
            const sourceName = _.get(sourceStreamInfo, "type", `Camera ${i + 1}`);
            const sourceLabel = _.get(sourceStreamInfo, "label", "");
            const has8K = sourceLabel.toLowerCase().includes("8k");

            let name = sourceName;
            if (sourceLabel) {
                name += ` (${sourceLabel})`;
            }

            const streams = [
                {
                    name: "Video",
                    videoIndex: i,
                    isVideo: true,
                    isEnhanced: false,
                    isStills: false,
                    disabled: has8K,
                },
            ];

            if (session.first_seen > 1631710005 && !includeVideoOnly) {
                streams.push({
                    name: "Low Bandwidth",
                    videoIndex: i,
                    isVideo: true,
                    isEnhanced: "low_res",
                    isStills: false,
                });
            }

            if (!includeVideoOnly) {
                streams.push({
                    name: "Still Images",
                    videoIndex: i,
                    isVideo: true,
                    isEnhanced: false,
                    isStills: true,
                });
            }

            sources.push({ name, streams });
        });
    }

    // Image sources
    if (playlist.image && playlist.image.length) {
        sources.push({
            name: `Camera ${sources.length + 1}`,
            streams: [
                {
                    name: "Stills",
                    videoIndex: 0,
                    isVideo: false,
                    isEnhanced: false,
                    isStills: false,
                },
            ],
        });
    }

    return sources;
};

export const getBearingOptions = (consolidatedHistory) => {
    return _.uniq(
        consolidatedHistory.map((session) => {
            return calculateBearingText(session.bearing);
        }),
    ).map((bearing) => {
        return bearing;
    });
};
